import { render, staticRenderFns } from "./ButtonThemed.vue?vue&type=template&id=4a21166d&lang=pug&"
import script from "./ButtonThemed.vue?vue&type=script&lang=js&"
export * from "./ButtonThemed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports